import React, { useContext, useEffect } from 'react'
import Setting from 'app/React/Components/Form/Setting'
import VariantSetting from 'app/React/Components/misc/VariantSetting'
import PaymentTypeSetting from 'app/React/Components/misc/PaymentTypeSetting'
import ColorSetting from 'app/React/Components/Form/ColorSetting'
import * as _ from 'remeda'
import LeasingKmField from 'app/React/Components/Form/LeasingKmField'
import IsLeasing from 'app/React/Components/misc/IsLeasing'
import SubmitButton from 'app/React/Components/Form/SubmitButton'
import IsDealerConfigurator from 'app/React/Components/misc/IsDealerConfiguration'
import SettingContainerStep3 from "app/React/Components/Form/Step3/SettingContainerStep3"
import { stepIsActive } from "app/React/Helpers/StepHelper";
import { ConfiguratorContext } from "app/React/ConfiguratorContainer";

export default function Form(props) {
  const {
    car,
    currentStep,
    colorSettingId,
    currentEngineTransmission,
    currentVariant,
    order,
    strings,
    setCurrentStep,
  } = useContext(ConfiguratorContext)

  const form = props.form
  const settings = Array.isArray(form.settings) ? { ...form.settings } : form.settings

  const paymentStrings = strings.payment_form ?? {}
  const dealerStrings = strings.payment_form?.dealer_checkout ?? {}

  const setting_elements = _.pipe(
    Object.keys(settings ?? {}),
    _.sortBy((key) => settings?.[key]?.ordering),
    _.map((key) => {
      const setting = settings[key]
      if (setting.layout === 'color') {
        return <ColorSetting key={key} setting={setting}/>
      }
      return <Setting key={key} setting={setting}/>
    })
  )

  useEffect(() => {
    const form_el = document.getElementsByClassName('form')
    if (form_el.length > 0) {
      form_el[0].scrollTo(0, 0)
    }
    window.scrollTo(0, 0)
  }, [])

  return (
    <SettingContainerStep3>
      <div className='form sticky' onScroll={props.onElScroll}>
        <h1 className='mobile-config-title config-title' ref={props.titleRef}>
          {form.title}
        </h1>
        {props.paymenttypesetting === true ? <PaymentTypeSetting/> : null}
        {props.variantsetting === true ? <VariantSetting/> : null}
        {props.leasingkmfield === true ? (
          <IsLeasing>
            <LeasingKmField tip={paymentStrings?.leasing_range?.tip}/>
          </IsLeasing>
        ) : null}
        {setting_elements}
        {props.children}
        {typeof form.description === 'string' && form.description.length > 0 ? (
          <div className='description wysiwyg' dangerouslySetInnerHTML={{ __html: form.description }}/>
        ) : null}

        <IsDealerConfigurator>
          <SubmitButton
            text={car.title}
            prefix={dealerStrings.configurating}
            buttonText={dealerStrings.next}
            onClick={(e) => {
              if (e.currentTarget.getAttribute('step_is_valid') === 'false') {
                return
              }

              const currentStepsKeys = Object.keys(currentVariant.steps)
              const validCurrentStepsKeys = currentStepsKeys.filter((key, index) => {
                // Only check for step 2,3,4, because they can have no active settings, based on payment type.
                if ([2, 3, 4].includes(currentVariant.steps[key]?.step_id) && !stepIsActive(
                  currentVariant.steps[key].settings,
                  currentVariant.steps[key]?.step_id,
                  colorSettingId,
                  currentEngineTransmission,
                  currentVariant,
                  order
                )) {
                  return false // There is no active settings
                }

                return true
              })

              const nextIndex = validCurrentStepsKeys.indexOf(String(currentStep)) + 1

              setCurrentStep(parseInt(validCurrentStepsKeys[nextIndex]))
            }}
          />
        </IsDealerConfigurator>
      </div>
    </SettingContainerStep3>
  )
}

Form.defaultProps = {
  variantsetting: false,
  paymenttypesetting: false,
  leasingkmfield: false
}
